import React, { useState, useEffect } from 'react';
import { Box, Button } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { authSelector } from 'redux/auth/selectors';
import PropTypes from 'prop-types';
import { defaultStyles } from 'utils/Theme';
import qHypercube from 'components/qvrf_component/hooks/qHyperCube';
import api from 'api';

const ValpakRedirectButton = ({ socket, buttonText }) => {
    const [redirectUrl, setRedirectUrl] = useState(null);
    const [isDisabled, setIsDisabled] = useState(true);
    const classes = defaultStyles();
    const { user } = useSelector(authSelector);

    const qDocPromise = socket.getDoc();

    const cols = [
        {
            qDef: {
                qLabel: 'SURVEY ACCESS STATUS',
                /**
                 * TODO: Update expression to use valpak survey access fields
                 * [Sales Rep Name] to be replaced with [Email]
                 * 'Amilia Craig' to be replaced with the currently logged in user's email
                 * ['Sales Rep'] to be replaced with the [Survey Access Status]
                 */
                qDef: `=Only({<[Sales Rep Name]={'Amalia Craig'}>}['Sales Rep'])`,
            },
        },
    ];

    const { qData } = qHypercube({
        qDocPromise,
        cols,
        qPage: {
            qTop: 0,
            qLeft: 0,
            qWidth: 2,
            qHeight: 2,
            qInterColumnSortOrder: [0, 1, 2],
        },
    });

    const handleRedirect = () => {
        window.location.href = redirectUrl;
    };

    const getUserSurveyAccessStatus = () => {
        return qData?.qMatrix[0][0].qText;
    };

    const getButtLoginURL = async () => {
        const url = await api.auth.valpakSSO.loginUrl();
        if (url) {
            setRedirectUrl(url);
            setIsDisabled(false);
        }
    };

    useEffect(() => {
        const surveyAccessStatus = getUserSurveyAccessStatus();

        // TODO: 103 Below to be replaced with the active status of the survey, only
        if (!redirectUrl && surveyAccessStatus === '103') {
            getButtLoginURL();
        }
    }, [qData, redirectUrl]);

    return (
        <Box
            className={'u-pv-xsmall'}
            display={'flex'}
            width={'100%'}
            justifyContent={'flex-end'}
        >
            <Button
                className={classes.buttonPrimary}
                disabled={isDisabled}
                onClick={handleRedirect}
            >
                {buttonText || 'LOGIN TO VALPAK'}
            </Button>
        </Box>
    );
};
ValpakRedirectButton.propTypes = {
    qsOptions: PropTypes.object,
    buttonText: PropTypes.string,
    socket: PropTypes.object,
};

export default ValpakRedirectButton;
